import React, {useContext} from 'react'
import {Alert, Button, Grid,} from '@mui/material'
import {AppContext} from '../../contexts/AppContextProvider'
import {Product} from '../../contexts/types'
import ControlContainer from '../ControlContainer'
import {CancelButton, PreviousButton} from '../StepperButtons'
import {OrgCustomizationContext} from "../../themes/OrgCustomizationProvider";
import ProductSearchInput from "../Inputs/ProductSearchInput";
import useUnknownProduct from "../../hooks/useUnknownProduct";
import {setSelectedProduct} from "../../contexts/GeneralComplaintReducer";
import {setMainProductReplacement} from "../../contexts/ReplacementsReducer";
import UseTheHackiestPageNavigation from "../../hooks/useTheHackiestPageNavigation";
import SelectedProductDisplay from "../SelectedProductDisplay";

const ProductSearch: React.FC = () => {
    const {navigateForward} = UseTheHackiestPageNavigation()
    const {t, ThirdPartyError} = useContext(OrgCustomizationContext)
    const {complaint, dispatch} = useContext(AppContext)
    const {
        unknownProduct,
        isProductUnknown,
        setIsProductUnknown
    } = useUnknownProduct(complaint.generalComplaint.isProductUnknown)

    const navigateToDetailsPage = (item?: Product) => {
        dispatch(setSelectedProduct(!item, item ? item : unknownProduct))
        dispatch(setMainProductReplacement(item?.isDiscontinuedOrUnknown ? undefined : item))

        if (item === undefined || item?.isFirstPartyManufactured === true) navigateForward()
    }

    const isThirdParty = complaint.generalComplaint.selectedProduct && !complaint.generalComplaint.selectedProduct.isFirstPartyManufactured

    return (
        <Grid container>
            <Grid item xs={12}>
                {!(complaint.generalComplaint.selectedProduct && isThirdParty) &&
                    <ProductSearchInput
                        value={complaint.generalComplaint.selectedProduct}
                        onChange={i => navigateToDetailsPage(i)}
                        isProductUnknown={isProductUnknown}
                        setIsProductUnknown={setIsProductUnknown}
                        searchCurrentProducts
                        searchOldProducts
                    />
                }

                {complaint.generalComplaint.selectedProduct && isThirdParty &&
                    <SelectedProductDisplay
                        product={complaint.generalComplaint.selectedProduct}
                        sx={{mt: 3}}
                        endAdornment={<Button onClick={() => {
                            dispatch(setSelectedProduct(undefined, undefined))
                            dispatch(setMainProductReplacement(undefined))
                        }}>
                            {t('clear')}
                        </Button>}
                    />
                }

                <br/>

                {complaint.generalComplaint.selectedProduct && isThirdParty &&
                    <Alert color='error'>
                        <ThirdPartyError/>
                    </Alert>
                }

                <ControlContainer>
                    {isProductUnknown && (
                        <Button
                            size='large'
                            variant='contained'
                            color='primary'
                            onClick={() => navigateToDetailsPage(isProductUnknown ? undefined : complaint.generalComplaint.selectedProduct)}
                        >
                            {t('continue')}
                        </Button>
                    )}

                    <PreviousButton/>

                    <CancelButton/>
                </ControlContainer>
            </Grid>
        </Grid>
    )
}

export default ProductSearch
